export default {
  modalHeader: 'Pripojiť náhradné diely',
};
